import { Spin } from 'antd';
import { useParams } from 'react-router-dom';

import { useUserInformation } from '@/hooks/use-user-information';

import { useUpdateBillingInformation } from '../mutations/billing-information';
import { useBillingInformationDetail } from '../queries/billing-information';
import type { BillingInformationRequest } from '../types';
import { BillingInformationForm } from './forms/billing-information-form';

interface OrganizationInformationProps {
  activeKey: string;
}

export function OrganizationBillingInformation({
  activeKey,
}: Readonly<OrganizationInformationProps>) {
  const { id } = useParams();
  const { organizationId } = useUserInformation();
  const currentOrganizationId = id ?? organizationId!;
  const { data, isFetching, isFetchedAfterMount } = useBillingInformationDetail(
    currentOrganizationId,
    { enabled: activeKey === 'billing' },
  );

  const { mutate: updateBillingInformation } = useUpdateBillingInformation();

  function handleUpdateBillingInformation(values: BillingInformationRequest) {
    const { invoice_managements, ...rest } = values;
    const requestBody = {
      invoice_managements: invoice_managements?.map(item => {
        if (!item.acode) delete item.acode;
        if (!item.beneficiary_account) delete item.beneficiary_account;
        return item;
      }),
      ...rest,
    };
    updateBillingInformation({ id: currentOrganizationId, requestBody });
  }

  if (isFetching && !isFetchedAfterMount) return <Spin size="small" />;

  return (
    <BillingInformationForm
      initialValues={data}
      onFinish={handleUpdateBillingInformation}
    />
  );
}
